export function getAdminAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('pgmart_admin_token') || sessionStorage.getItem('pgmart_admin_token') || localStorage.getItem('terra_admin_token') || '';
  return token ? { 
    'Authorization': `Bearer ${token}`,
    'x-admin-token': token,
    'X-Admin-Token': token
  } : {};
}

export async function adminFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('pgmart_admin_token') || sessionStorage.getItem('pgmart_admin_token') || localStorage.getItem('terra_admin_token') || '';
  const headers = new Headers(options.headers || {});
  if (!headers.has('Authorization') && token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (!headers.has('x-admin-token') && token) {
    headers.set('x-admin-token', token);
  }
  if (!headers.has('X-Admin-Token') && token) {
    headers.set('X-Admin-Token', token);
  }
  if (!headers.has('Cache-Control')) {
    headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
  }
  if (!headers.has('Pragma')) {
    headers.set('Pragma', 'no-cache');
  }

  const method = (options.method || 'GET').toUpperCase();
  if (['PUT', 'DELETE', 'PATCH'].includes(method)) {
    headers.set('X-HTTP-Method-Override', method);
  }

  try {
    const res = await fetch(url, {
      ...options,
      cache: options.cache || 'no-store',
      headers,
    });

    // If web server returned 501 (Not Implemented) or 405 (Method Not Allowed) for native PUT/DELETE/PATCH,
    // seamlessly retry via POST with method override parameter.
    if ((res.status === 501 || res.status === 405) && ['PUT', 'DELETE', 'PATCH'].includes(method)) {
      const fallbackUrl = url.includes('?') ? `${url}&_method=${method}` : `${url}?_method=${method}`;
      return await fetch(fallbackUrl, {
        ...options,
        method: 'POST',
        headers,
      });
    }

    return res;
  } catch (err) {
    // Network or server method rejection fallback
    if (['PUT', 'DELETE', 'PATCH'].includes(method)) {
      const fallbackUrl = url.includes('?') ? `${url}&_method=${method}` : `${url}?_method=${method}`;
      return await fetch(fallbackUrl, {
        ...options,
        method: 'POST',
        headers,
      });
    }
    throw err;
  }
}

